// TaskItem.tsx
import React from 'react';
import { List, Button, Typography, Image } from 'antd';
import { EditOutlined, DeleteOutlined, PaperClipOutlined } from '@ant-design/icons';
import { TaskItemProps } from './types';
import { getBaseUrl } from '../../../../../api/axiosInstance';

const { Text } = Typography;

const TaskItem: React.FC<TaskItemProps> = ({ 
    task, 
    statusTag, 
    onEdit, 
    onDelete, 
    isDeleted 
}) => {
    // Функция для получения URL изображения по ID
    const getImageUrl = (imageId: string) => {
        return `${getBaseUrl()}/server/olympiad/files/img?id=${imageId}`;
    };

    return (
        <List.Item
            className={`task-item ${isDeleted ? 'task-deleted' : ''}`}
            actions={[
                statusTag,
                <Button
                    type="text"
                    icon={<EditOutlined />}
                    onClick={() => onEdit(task)}
                    size="small"
                    className="edit-btn"
                >
                    {isDeleted ? 'Восстановить' : 'Редакт.'}
                </Button>,
                !isDeleted && (
                    <Button
                        type="text"
                        danger
                        icon={<DeleteOutlined />}
                        onClick={() => onDelete(task.id)}
                        size="small"
                        className="delete-btn"
                    >
                        Удалить
                    </Button>
                )
            ]}
        >
            <div className="task-content">
                <div className="task-question">
                    <Text strong className="question-label">Вопрос: </Text>
                    <Text className="question-text">{task.question}</Text>
                </div>
                <div className="task-answer">
                    <Text strong className="answer-label">Ответ: </Text>
                    <Text className="answer-text">{task.answer}</Text>
                </div>
                {task.imageId && (
                    <div className="task-file">
                        <PaperClipOutlined style={{ marginRight: 4 }} />
                        <Image
                            width={100}
                            src={getImageUrl(task.imageId)}
                            alt={task.fileName || 'Прикрепленное изображение'}
                            preview={{
                                mask: 'Просмотр',
                            }}
                        />
                        <a 
                            href={getImageUrl(task.imageId)} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            onClick={(e) => e.stopPropagation()}
                            style={{ marginLeft: 8 }}
                        >
                            {task.fileName || 'Прикрепленное изображение'}
                        </a>
                    </div>
                )}
            </div>
        </List.Item>
    );
};

export default TaskItem;